import React from "react";
import { EXPERIENCES } from "../constants/constant";
import { motion } from "framer-motion";

const Experience = () => {
  return (
    <div id="experience" className=" border-b border-neutral-300 pb-4 dark:border-neutral-900 ">
      <motion.h2
        whileInView={{ opacity: 1, y: 0 }}
        initial={{ opacity: 0, y: -100 }}
        transition={{ duration: 1.5 }}
        className=" my-20 text-center text-4xl"
      >
        Experience
      </motion.h2>
      <div>
        {EXPERIENCES.map((exp, index) => (
          <div key={index} className="mb-8 flex flex-wrap lg:justify-center">
            <motion.div
              whileInView={{ opacity: 1, x: 0 }}
              initial={{ opacity: 0, x: -100 }}
              transition={{ duration: 1 }}
              className=" w-full lg:w-1/4"
            >
              <p className=" mb-2 text-sm text-neutral-600 dark:text-neutral-400">
                {exp.year}
              </p>
            </motion.div>
            <motion.div
              whileInView={{ opacity: 1, x: 0 }}
              initial={{ opacity: 0, x: 100 }}
              transition={{ duration: 1 }}
              className=" w-full max-w-xl lg:w-3/4"
            >
              <h6 className=" mb-2 font-semibold">
                {exp.role}-{" "}
                <span className=" text-sm text-purple-600 dark:text-purple-100">
                  {exp.company}
                </span>
              </h6>
              <p className=" mb-4 whitespace-pre-line text-neutral-600 dark:text-neutral-400">
                {exp.description}
              </p>
              {/* Added a div wrapper with flex-wrap and gap-x-2 gap-y-2 */}
              <div className="flex flex-wrap gap-x-2 gap-y-2">
                {exp.technologies.map((tech, techIndex) => (
                  <span
                    key={techIndex} // Changed index to techIndex for unique keys within the map
                    className="rounded bg-neutral-200 px-2 py-1 text-sm font-medium text-purple-700 dark:bg-neutral-900 dark:text-purple-300"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </motion.div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Experience;
